import { render, staticRenderFns } from "./NDSkladZakPolozky.vue?vue&type=template&id=01f92f2f&"
import script from "./NDSkladZakPolozky.vue?vue&type=script&lang=ts&"
export * from "./NDSkladZakPolozky.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports